import { Droplets, Sun, Battery, Wrench, House } from "lucide-react";
import Reveal from "@/components/layout/Reveal";

const PHASES = [
  { phase: "Phase 1", title: "Hot Water Heat Pumps", body: "Replace gas & electric cylinders with high-efficiency heat pump hot water.", icon: Droplets, now: true },
  { phase: "Phase 2", title: "Solar PV", body: "Self-generate clean electricity to power your hot water and home.", icon: Sun },
  { phase: "Phase 3", title: "Home Battery Storage", body: "Store solar energy for evening use and grid backup.", icon: Battery },
  { phase: "Phase 4", title: "Monoblock Heating", body: "Move space heating and hot water onto efficient electric heat pumps.", icon: Wrench },
  { phase: "Phase 5", title: "Zero Carbon Home", body: "Whole-home electrification — comfortable, low-cost, low-emission.", icon: House },
];

export const StagedVisionTimelineSection = () => {
  return (
    <section className="py-20 sm:py-28 bg-[#0B132B] text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-[0.04]" />
      <div className="max-w-7xl mx-auto px-6 sm:px-8 relative">
        <Reveal className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#10B981]/20 text-[#10B981] text-[11px] font-semibold tracking-widest uppercase">
            <span className="h-1.5 w-1.5 rounded-full bg-[#10B981]" /> Our staged vision
          </span>
          <h2 className="font-heading mt-4 text-3xl sm:text-5xl font-bold tracking-tight">
            From hot water to a fully electric Kiwi home.
          </h2>
        </Reveal>

        <div className="mt-16 relative">
          <div className="absolute left-4 sm:left-1/2 -translate-x-px top-0 bottom-0 w-px bg-white/15" />
          {PHASES.map((s, i) => (
            <Reveal key={i} delay={i * 80}>
              <div className={`relative flex flex-col sm:flex-row items-start sm:items-center gap-6 mb-10 ${i % 2 === 1 ? "sm:flex-row-reverse" : ""}`}>
                <div className="absolute left-4 sm:left-1/2 -translate-x-1/2 flex h-9 w-9 items-center justify-center rounded-full bg-[#10B981] text-[#0B132B] z-10">
                  <s.icon className="h-4 w-4" strokeWidth={2.2} />
                </div>
                <div className={`sm:w-1/2 pl-16 sm:pl-0 ${i % 2 === 1 ? "sm:pr-16 sm:text-right" : "sm:pl-16"}`}>
                  <p className="text-xs uppercase tracking-widest text-[#10B981] font-semibold">{s.phase} {s.now && <span className="ml-2 px-2 py-0.5 rounded-full bg-[#10B981] text-[#0B132B] text-[10px]">NOW</span>}</p>
                  <h3 className="font-heading text-2xl font-semibold mt-1">{s.title}</h3>
                  <p className="mt-2 text-white/70 max-w-md">{s.body}</p>
                </div>
                <div className="hidden sm:block sm:w-1/2" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
